import React, { useEffect, useState } from "react";
import { Animated, Dimensions, Platform, ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens, StepperTypeTokens, TextAlignTokens, TypographyTypeDLS } from "@voltmoney/schema";
import ThemeProvider from '@voltmoney/theme';
import { ModalAlignmentEnum, SCREEN_SIZE } from '@voltmoney/types';
import BottomSheet from "../BottomSheet";
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { Space } from "../../space/Space";
import LottieView from "lottie-react-native";
import { Button } from "../../button/Button";
import Image from '../../image/Image';
import { Header } from "../../header/Header";
import { isMobile } from "../../stack/utils";
import { Divider } from "../../divider/Divider";
import { isFromTDLPlatform } from "../utils";
const BankSelect = ({ bankData, profileAction, stepperData, triggerAction, backAction, applyAction, modalState, continuePress, userName, height, needHelpAction, isFromJupiter }) => {
    const stepperProps = {
        data: stepperData,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null
    };
    const [SlideInLeft, setSlideIn] = useState(new Animated.Value(0));
    const [showModal, setShowModal] = useState(false);
    const [rupeeLottie, setRupeeLottie] = useState("");
    const [successLottie, setSuccessLottie] = useState("");
    const [selectedValue, setSelectedValue] = useState("");
    const [cardState, setModalState] = useState("Penny");
    const [modalHeight, setModalHeight] = useState(332);
    const [selectedObject, setSelectedObject] = useState({});
    const [isDismissable, setDismissable] = useState(false);
    const theme = ThemeProvider.getTheme();
    const fontFamilyMapping = theme.fontFamily;
    let bgColor = theme.colors[ColorTokens.Primary_100];
    const _start = () => {
        return Animated.timing(SlideInLeft, {
            toValue: 1,
            duration: 500,
            useNativeDriver: true
        }).start();
    };
    const [showCard, setShowCard] = useState(false);
    const toggleCard = () => {
        setShowCard(!showCard);
    };
    useEffect(() => {
        console.warn("REACHED MODAL STATE", modalState);
        if (modalState) {
            if (modalState === 'error') {
                setDismissable(true);
                setModalHeight(244);
            }
            if (modalState === 'success') {
                setModalHeight(228);
            }
            setModalState(modalState);
        }
        else {
            setModalState("Penny");
        }
    }, [modalState]);
    const renderVerificationSuccess = () => {
        return (React.createElement(View, { style: { padding: 16, alignItems: "center", flex: 1 } },
            React.createElement(LottieView, { source: successLottie, style: { width: 70, height: 'auto' }, autoPlay: true, loop: true }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { label: "Account verified successfully", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: { marginTop: 4 } },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: "You will be redirected to next step in few seconds", fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 32 })),
            React.createElement(View, { style: { position: 'absolute', bottom: 0, width: '100%', paddingHorizontal: 16, marginBottom: 10 } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: "Continue", width: ButtonWidthTypeToken.FULL, onPress: () => {
                        if (continuePress) {
                            triggerAction(continuePress);
                        }
                    } }))));
    };
    const renderErrorContent = () => {
        return (React.createElement(View, { style: { padding: 16, alignItems: "center", flex: 1 } },
            React.createElement(Icon, { name: IconTokens.SystemError, size: IconSizeTokens.XXXXXXL }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { label: "Invalid bank account", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, paddingTop: 32 })),
            React.createElement(View, { style: {
                    marginTop: 24,
                    backgroundColor: '#FEF4E6',
                    width: '100%',
                    padding: 8,
                    marginBottom: 8,
                    borderRadius: 8
                } },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: "Please verify account details and try again", fontSize: FontSizeTokens.SM, fontWeight: '400', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, paddingTop: 32 })),
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    paddingHorizontal: 16,
                    paddingBottom: 8,
                    marginBottom: 4
                } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, label: "Try another bank account", width: ButtonWidthTypeToken.FULL, onPress: () => {
                        setShowModal(false);
                        setModalState("Penny");
                        setModalHeight(332);
                    } }))));
    };
    const renderPennyDropContent = () => {
        return (React.createElement(View, { style: { padding: 16, alignItems: "center", flex: 1 } },
            Platform.OS !== 'web' && React.createElement(LottieView, { source: { uri: "https://lottie.host/78420adf-df0a-4fa2-a500-36bbf2ac0762/YkUlAx1j0n.json" }, style: { width: 99, height: 99, }, autoPlay: true, loop: true }),
            Platform.OS === 'web' &&
                React.createElement(LottieView, { source: rupeeLottie, style: { width: 99, height: 'auto' }, autoPlay: true, loop: true }),
            React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, label: "Depositing ₹1", fontWeight: 'bold', fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, paddingTop: 16 }),
            React.createElement(View, { style: { width: '100%', backgroundColor: '#FEF4E6', padding: 16, marginTop: 24, borderRadius: 8 } },
                React.createElement(Text, { style: {
                        textAlign: 'center',
                        fontFamily: isFromTDLPlatform() ? 'InterSimonson' : fontFamilyMapping.Inter,
                        fontSize: 14,
                        color: '#1D2939',
                        fontWeight: '400',
                        lineHeight: 20
                    } },
                    "To verify account, we will deposit \u20B91 and match account holder name with name as per PAN \"",
                    React.createElement(Text, { style: [styles.boldText, { fontFamily: isFromTDLPlatform() ? 'InterSimonson' : fontFamilyMapping.Inter,
                            }] }, userName),
                    "\".")),
            React.createElement(View, { style: { position: 'absolute', bottom: 0, marginBottom: 10 } },
                React.createElement(Typography, { label: "It may take up to 30 seconds..." }))));
    };
    const getUniqueIdentifierBankAccount = (item) => {
        return `${item.accountNumber}_${item.ifscCode}`;
    };
    const renderBankCard = (item) => {
        return (React.createElement(View, { nativeID: 'rb_bankVerification_' + item.bankName },
            React.createElement(TouchableOpacity, { onPress: () => {
                    if (selectedValue === item.accountNumber) {
                        setSelectedValue("");
                        setSelectedObject({});
                    }
                    else {
                        setSelectedValue(getUniqueIdentifierBankAccount(item));
                        setSelectedObject(item);
                    }
                }, style: {
                    borderColor: getUniqueIdentifierBankAccount(item) === selectedValue ? bgColor : '#E4E7EC',
                    borderWidth: 1,
                    flexDirection: 'row',
                    paddingTop: 15,
                    paddingLeft: 12,
                    paddingRight: 12,
                    paddingBottom: 12,
                    marginBottom: 8,
                    borderRadius: 8,
                    width: '100%',
                    backgroundColor: getUniqueIdentifierBankAccount(item) === selectedValue ? '#FAFBFE' : 'white',
                } },
                React.createElement(View, { style: { flexDirection: 'row', flex: 1 } },
                    React.createElement(View, { style: { flexDirection: 'column', justifyContent: 'center' } },
                        React.createElement(Icon, { name: getUniqueIdentifierBankAccount(item) === selectedValue
                                ? IconTokens.RadioCircleFilled
                                : IconTokens.RadioCircleNotFilled, size: IconSizeTokens.XL })),
                    React.createElement(Space, { size: SizeTypeTokens.LG }),
                    React.createElement(View, { style: { flexDirection: 'column' } },
                        React.createElement(Typography, { label: `${item.bankName}`, color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, paddingTop: 0 }),
                        React.createElement(Space, { size: SizeTypeTokens.SM }),
                        React.createElement(Typography, { label: "XXXX " + item.accountNumber.slice(-4), color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.MD, fontWeight: '600', lineHeight: 24, paddingTop: 0 }))),
                React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(Space, { size: SizeTypeTokens.XXXL }),
                    React.createElement(Image, { uri: `https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${item.ifscCode.substring(0, 4)}.png`, size: ImageSizeTokens.Size_40, borderRadius: BorderRadiusTokens.BR5 })))));
    };
    const modalContentPresenter = () => {
        switch (cardState) {
            case "Penny": {
                return renderPennyDropContent();
                break;
            }
            case "success": {
                return renderVerificationSuccess();
                break;
            }
            case "error": {
                return renderErrorContent();
                break;
            }
            default: {
                return renderPennyDropContent();
                break;
            }
        }
    };
    useEffect(() => {
        fetch("https://lottie.host/78420adf-df0a-4fa2-a500-36bbf2ac0762/YkUlAx1j0n.json", {
            method: "GET",
        })
            .then((response) => response.json())
            .then((responseData) => {
            console.log(responseData);
            setRupeeLottie(responseData);
        })
            .catch((error) => {
            console.log(error);
        });
        fetch("https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json", {
            method: "GET",
        })
            .then((response) => response.json())
            .then((responseData) => {
            console.log(responseData);
            setSuccessLottie(responseData);
        })
            .catch((error) => {
            console.log(error);
        });
        _start();
        return () => {
            setModalHeight(332);
            setModalState('Penny');
            setShowModal(false);
        };
    }, []);
    const renderEmptyState = () => {
        return (React.createElement(View, { style: [styles.blankContainer, { height: Platform.OS === "ios" ? height - 20 : height }] },
            React.createElement(View, { style: [styles.header, { paddingHorizontal: 16 }] },
                React.createElement(Header, { id: "bt_bankVerification_goBack", type: HeaderTypeTokens.verification, stepperProps: stepperProps, isBackButton: true, needHelpIcon: true, title: "Link bank account", isFromJupiter: isFromJupiter, needHelpAction: () => triggerAction(needHelpAction), onPress: () => {
                        if (backAction) {
                            triggerAction(backAction);
                        }
                    } })),
            React.createElement(View, { style: {
                    paddingHorizontal: 16,
                    flex: 1
                } },
                React.createElement(View, { style: { marginTop: 24 } },
                    React.createElement(Image, { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/bank_verifying_details.png", size: ImageSizeTokens.SIZE_64 })),
                React.createElement(View, { style: { marginTop: 4, alignItems: 'flex-start', alignSelf: 'flex-start' } },
                    React.createElement(Typography, { label: "Proceed to add bank account", fontWeight: '600', fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins }),
                    React.createElement(Typography, { label: "Add a bank account for disbursal", fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter })),
                React.createElement(View, { style: { alignSelf: 'center', marginTop: 110 } })),
            React.createElement(View, { style: { bottom: 0, position: 'absolute', width: "100%", marginBottom: 16 } },
                React.createElement(View, { style: { marginBottom: 16 } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                React.createElement(View, { style: { paddingHorizontal: 16 } },
                    React.createElement(Button, { id: "bt_bankVerification_addBankAccount", type: ButtonTypeTokens.LargeFilled, label: "Add bank account", fontSize: FontSizeTokens.SM, width: ButtonWidthTypeToken.FULL, onPress: () => {
                            if (profileAction) {
                                triggerAction(profileAction);
                            }
                        } })))));
    };
    const containsOnlyMfcBankDetails = (bankData) => {
        if (!bankData || bankData?.length === 0) {
            return false;
        }
        return bankData?.every(bank => bank?.bankFetchSource === 'MFC_FETCH');
    };
    return bankData.length === 0 ? renderEmptyState() : (React.createElement(View, { style: [styles.container, { height: Platform.OS === "ios" ? height - 16 : height }] },
        React.createElement(View, { style: styles.contentContainer },
            React.createElement(View, { style: styles.header },
                React.createElement(Header, { id: "bt_bankVerification_goBack", type: HeaderTypeTokens.verification, stepperProps: stepperProps, isBackButton: true, title: "Link bank account", onPress: () => {
                        if (backAction) {
                            triggerAction(backAction);
                        }
                    } })),
            React.createElement(View, { style: { marginTop: 24, } },
                React.createElement(Typography, { label: "Select bank account for receiving cash", fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '600', paddingTop: 24, lineHeight: 24, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { height: height - 150 } },
                bankData &&
                    containsOnlyMfcBankDetails(bankData) &&
                    React.createElement(React.Fragment, null,
                        React.createElement(View, { style: { height: 8 } }),
                        React.createElement(View, { style: [styles.messageContainer, { backgroundColor: theme.colors[ColorTokens.Secondary_05] }] },
                            React.createElement(Icon, { name: IconTokens.SecureIcon, size: IconSizeTokens.LG }),
                            React.createElement(View, { style: { width: 12 } }),
                            React.createElement(Typography, { label: 'Your bank accounts were securely fetched from MFCentral', typeDLS: TypographyTypeDLS.B2R }))),
                React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'flex-end', marginTop: 16 } }, !showModal &&
                    React.createElement(TouchableOpacity, { style: { flexDirection: "row", justifyContent: 'center' }, onPress: () => {
                            if (profileAction) {
                                triggerAction(profileAction);
                            }
                        } },
                        Platform.OS !== 'web' ?
                            React.createElement(View, { style: { marginTop: 2 } },
                                React.createElement(Icon, { name: IconTokens.Plus, size: IconSizeTokens.MD }))
                            :
                                React.createElement(View, { style: { marginRight: 4, marginTop: 2 } },
                                    React.createElement(Icon, { name: IconTokens.Plus, size: IconSizeTokens.MD })),
                        React.createElement(Typography, { id: "bt_bankVerification_addBank", color: ColorTokens.Primary_100, label: " Add Bank account", fontWeight: '600', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20 }))),
                React.createElement(ScrollView, { style: {
                        marginTop: 12,
                        marginBottom: 98,
                        paddingBottom: Platform.OS === "ios" ? 60 : 40,
                        flex: 1
                    } }, bankData?.map((bank) => {
                    return (React.createElement(Animated.View, { style: {
                            transform: [
                                {
                                    translateX: SlideInLeft.interpolate({
                                        inputRange: [0, 1],
                                        outputRange: [600, 0]
                                    })
                                }
                            ],
                            flex: Platform.OS !== 'web' ? 0 : 1,
                            height: Platform.OS !== 'web' ? 100 : 250,
                            width: '100%',
                            borderRadius: 12,
                            backgroundColor: "white",
                            marginTop: Platform.OS !== 'web' ? 0 : 12
                        } }, renderBankCard(bank)));
                })))),
        React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                width: '100%',
                justifyContent: 'center',
                borderTopWidth: 1,
                borderColor: '#F1F3F5',
                paddingHorizontal: -16,
                paddingVertical: 8,
                backgroundColor: 'white',
                ...Platform.OS === 'ios' && {
                    paddingBottom: 4
                }
            } },
            React.createElement(View, { style: { alignContent: 'center', alignItems: 'center', marginTop: 8 } },
                React.createElement(Typography, { label: "We'll match account holder name with PAN records", fontSize: FontSizeTokens.XS, fontWeight: '400', lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter })),
            React.createElement(View, { style: styles.bottomCTA },
                React.createElement(Button, { id: "bt_bankVerification_verifyBankAccount", type: selectedValue !== "" ? ButtonTypeTokens.LargeFilled : ButtonTypeTokens.LargeOutline, width: ButtonWidthTypeToken.FULL, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: "Verify bank account", onPress: () => {
                        setShowModal(true);
                        setModalHeight(332);
                        setModalState("Penny");
                        if (applyAction) {
                            triggerAction({
                                ...applyAction,
                                payload: { selectedItem: selectedObject },
                            });
                        }
                    } }))),
        showModal &&
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: () => setShowModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: isDismissable, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height + 10 : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 504, routeId: "routeId", handleKeyboard: true }, modalContentPresenter()))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        height: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height - 70 : Dimensions.get('window').height - 114,
    },
    blankContainer: {
        height: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height - 70 : Dimensions.get('window').height - 114,
    },
    header: {
        marginHorizontal: -16, ...Platform.OS === "ios" && {
            marginTop: 24
        }
    },
    backdrop: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    backdropText: {
        color: 'white',
        fontSize: 16,
    },
    contentContainer: {
        paddingHorizontal: 16,
        flex: 1
    },
    card: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        height: '50%',
        padding: 20,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
    },
    cardText: {
        fontSize: 18,
    },
    boldText: {
        fontWeight: 'bold',
        color: '#1D2939',
        fontSize: 14
    },
    bottomCTA: {
        paddingHorizontal: 16,
        marginTop: 8,
        marginBottom: 6,
        ...Platform.OS === "ios" && {
            paddingBottom: 12,
            marginTop: 12
        }
    },
    messageContainer: {
        paddingHorizontal: 12,
        paddingVertical: 8,
        display: 'flex',
        flexDirection: 'row',
        borderRadius: 8
    }
});
export default (BankSelect);
